import { Flex } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Page from '@feathr/extender/App/Page';
import { useAccount } from '@feathr/extender/state';

import { useMetaConnectionToggle } from './MetaIntegrationPage.hooks';
import { MetaConnectedBadge, MetaConnectedView, MetaSettingsButton } from './PostConnection';
import { MetaConnectButton, MetaOnboardingView } from './PreConnection';

function MetaIntegrationPage(): JSX.Element {
  const account = useAccount();
  const { t } = useTranslation();
  const isConnected = useMetaConnectionToggle();

  return (
    <Page
      actions={isConnected ? <MetaSettingsButton /> : <MetaConnectButton />}
      ChipsComponent={
        isConnected ? (
          <Flex>
            <MetaConnectedBadge />
          </Flex>
        ) : undefined
      }
      collapseHeader={false}
      collapseHeaderOnScroll={true}
      description={
        isConnected
          ? undefined
          : t(
              'Integrate your Facebook Business Manager and Instagram accounts to create, manage, and optimize paid social campaigns alongside your other marketing efforts.',
            )
      }
      includeCurrentPageCrumb={true}
      loading={account.isPending}
      title={isConnected ? t('Meta Integration') : t('Connect Meta for Paid Social Advertising')}
    >
      {isConnected ? <MetaConnectedView /> : <MetaOnboardingView />}
    </Page>
  );
}

export default observer(MetaIntegrationPage);
